import {
    defaultBaseQuery,
    transformErrorResponse,
    transformRequest,
    transformSuccessResponse
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

const AdminScholarshipApi = createApi({
    reducerPath: 'adminScholarshipApi',
    baseQuery: defaultBaseQuery,
    endpoints: (builder) => ({
        getAdminScholarships: builder.query({
            query: (params) => ({
                url: `scholarship`,
                method: 'GET',
                params: params,
                transformRequest: transformRequest
            }),
            transformErrorResponse: transformErrorResponse,
            transformResponse: transformSuccessResponse
        }),
        getAdminScholarshipById: builder.query({
            query: (id) => ({
                url: `scholarship/${id}`,
                method: 'GET',
                transformRequest: transformRequest
            }),
            transformErrorResponse: transformErrorResponse,
            transformResponse: transformSuccessResponse
        }),
        addAdminScholarship: builder.mutation({
            query: (payload) => ({
                url: `scholarship`,
                method: 'POST',
                body: payload,
                transformRequest: transformRequest
            }),
            transformErrorResponse: transformErrorResponse,
            transformResponse: transformSuccessResponse
        }),
        updateAdminScholarship: builder.mutation({
            query: ({ id, ...payload }) => ({
                url: `scholarship/${id}`,
                method: 'PUT',
                body: payload,
                transformRequest: transformRequest
            }),
            transformErrorResponse: transformErrorResponse,
            transformResponse: transformSuccessResponse
        }),
        deleteAdminScholarship: builder.mutation({
            query: (id) => ({
                url: `scholarship/${id}`,
                method: 'DELETE',
                transformRequest: transformRequest
            }),
            transformErrorResponse: transformErrorResponse,
            transformResponse: transformSuccessResponse
        })
    })
});

export const {
    useLazyGetAdminScholarshipsQuery,
    useLazyGetAdminScholarshipByIdQuery,
    useAddAdminScholarshipMutation,
    useUpdateAdminScholarshipMutation,
    useDeleteAdminScholarshipMutation
} = AdminScholarshipApi;

export default AdminScholarshipApi;
